define.alias("shared/components/shared/post/profile-selector/profile-list", "calendar/components/shared/post/profile-selector/profile-list/index");